import { useMutation, useQuery, useQueryClient } from "react-query";
import CertificationRequestService from "./CertificationRequestService";
import { message } from "antd";
import useAuth from "../../../../../core/hooks/useAuth";

const useCertificationRequests = () => {
  const queryClient = useQueryClient();
  const { authenticatedUser } = useAuth();

  const {
    data: certificationRequests,
    isLoading,
    error,
    refetch,
  } = useQuery("certificationRequests", CertificationRequestService.getAllCertificationRequests, {
    staleTime: 1000 * 60 * 5,
  });


  const approveRequest = useMutation(
    async ({ certId }) => {
      if (!authenticatedUser?.id) throw new Error("User is not authenticated!");
      return CertificationRequestService.approveCertificationRequest(certId, authenticatedUser.id);
    },
    {
      onSuccess: () => {
        message.success("Certification approved successfully!");
        refetch(); 
      },
      onError: (error) => {
        message.error(error.response?.data?.message || "Failed to approve certification.");
      },
    }
  );


  const rejectRequest = useMutation(
    async ({ certId }) => {
      if (!authenticatedUser?.id) throw new Error("User is not authenticated!");
      return CertificationRequestService.rejectCertificationRequest(certId, authenticatedUser.id);
    },
    {
      onSuccess: () => {
        message.success("Certification rejected successfully!");
        refetch(); 
      },
      onError: (error) => {
        message.error(error.response?.data?.message || "Failed to reject certification.");
      },
    }
  );

  return {
    certificationRequests,
    isLoading,
    error,
    approveRequest,
    rejectRequest,
  };
};

export default useCertificationRequests;
